import InternalStaticAnchorRankingList from 'models/application/anchor/types/internalStatic/types/RankingList';

export default class InternalStaticAnchorRankingListService {
	toModel(anchor) {
		return new InternalStaticAnchorRankingList(anchor);
	}
}
